// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .tarjeta-formulario {
  background-color: #fff;
} */

/* .tarjeta-formulario * {
  font-family: 'Roboto';
	font-weight: 400;
  font-size: 16px;
} */


.tarjeta-formulario .field {
  position: relative;
  height: 60px;
  min-height: 60px;
  margin-left: 15px;
  margin-right: 15px;
}

.tarjeta-formulario .baseline {
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  bottom: 0;
  background-color: #707070;
  transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.tarjeta-formulario label {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 8px;
  color: #707070;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transform-origin: 0 50%;
  cursor: text;
  transition-property: color, transform;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
}

.tarjeta-formulario .input {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  padding-bottom: 7px;
  color: #383838;
  background-color: transparent;
}

.tarjeta-formulario .input::-webkit-input-placeholder {
  color: transparent;
  -webkit-transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.tarjeta-formulario .input::-moz-placeholder {
  color: transparent;
  -moz-transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.tarjeta-formulario .input:-ms-input-placeholder {
  color: transparent;
  -ms-transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.tarjeta-formulario .input.StripeElement {
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  will-change: opacity;
}

.tarjeta-formulario .input.focused,
.tarjeta-formulario .input:not(.empty) {
  opacity: 1;
}

.tarjeta-formulario .input.focused::-webkit-input-placeholder,
.tarjeta-formulario .input:not(.empty)::-webkit-input-placeholder {
  color: #707070;
}

.tarjeta-formulario .input.focused::-moz-placeholder,
.tarjeta-formulario .input:not(.empty)::-moz-placeholder {
  color: #707070;
}

.tarjeta-formulario .input.focused:-ms-input-placeholder,
.tarjeta-formulario .input:not(.empty):-ms-input-placeholder {
  color: #707070;
}

.tarjeta-formulario .input.focused + label,
.tarjeta-formulario .input:not(.empty) + label {
  color: #888888;
  transform: scale(0.85) translateY(-25px);
  cursor: default;
}

.tarjeta-formulario .input.focused + label {
  color: #888888;
}

.tarjeta-formulario .input.invalid + label {
  color: red;
}

.tarjeta-formulario .input.focused + label + .baseline {
  background-color: #888888;
}

.tarjeta-formulario .input.focused.invalid + label + .baseline {
  background-color: #e25950;
}

.tarjeta-formulario input, .tarjeta-formulario button {
  appearance: none;
  outline: none;
  border-style: none;
}

.tarjeta-formulario input:-webkit-autofill {
  -webkit-text-fill-color: #e39f48;
  -webkit-transition: background-color 100000000s;
  transition: background-color 100000000s;
  animation: 1ms void-animation-out;
  -webkit-animation: 1ms void-animation-out;
}

.tarjeta-formulario .StripeElement--webkit-autofill {
  background: transparent !important;
}

.tarjeta-formulario input, .tarjeta-formulario button {
  animation: 1ms void-animation-out;
  -webkit-animation: 1ms void-animation-out;
}
`, "",{"version":3,"sources":["webpack://./src/app/componentes/pasarela-stripe/stripe.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;;;;GAIG;;;AAGH;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,OAAO;EACP,SAAS;EACT,yBAAyB;EACzB,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qCAAqC;EACrC,yBAAyB;EACzB,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iEAAyD;EAAzD,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,8DAAyD;EAAzD,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,6DAAyD;EAAzD,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,2DAA2D;EAC3D,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAGE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,+CAAuC;EAAvC,uCAAuC;EACvC,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C","sourcesContent":["/* .tarjeta-formulario {\n  background-color: #fff;\n} */\n\n/* .tarjeta-formulario * {\n  font-family: 'Roboto';\n\tfont-weight: 400;\n  font-size: 16px;\n} */\n\n\n.tarjeta-formulario .field {\n  position: relative;\n  height: 60px;\n  min-height: 60px;\n  margin-left: 15px;\n  margin-right: 15px;\n}\n\n.tarjeta-formulario .baseline {\n  position: absolute;\n  width: 100%;\n  height: 1px;\n  left: 0;\n  bottom: 0;\n  background-color: #707070;\n  transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n\n.tarjeta-formulario label {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  bottom: 8px;\n  color: #707070;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  transform-origin: 0 50%;\n  cursor: text;\n  transition-property: color, transform;\n  transition-duration: 0.3s;\n  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n\n.tarjeta-formulario .input {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  bottom: 0;\n  padding-bottom: 7px;\n  color: #383838;\n  background-color: transparent;\n}\n\n.tarjeta-formulario .input::-webkit-input-placeholder {\n  color: transparent;\n  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n\n.tarjeta-formulario .input::-moz-placeholder {\n  color: transparent;\n  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n\n.tarjeta-formulario .input:-ms-input-placeholder {\n  color: transparent;\n  transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n\n.tarjeta-formulario .input.StripeElement {\n  opacity: 0;\n  transition: opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);\n  will-change: opacity;\n}\n\n.tarjeta-formulario .input.focused,\n.tarjeta-formulario .input:not(.empty) {\n  opacity: 1;\n}\n\n.tarjeta-formulario .input.focused::-webkit-input-placeholder,\n.tarjeta-formulario .input:not(.empty)::-webkit-input-placeholder {\n  color: #707070;\n}\n\n.tarjeta-formulario .input.focused::-moz-placeholder,\n.tarjeta-formulario .input:not(.empty)::-moz-placeholder {\n  color: #707070;\n}\n\n.tarjeta-formulario .input.focused:-ms-input-placeholder,\n.tarjeta-formulario .input:not(.empty):-ms-input-placeholder {\n  color: #707070;\n}\n\n.tarjeta-formulario .input.focused + label,\n.tarjeta-formulario .input:not(.empty) + label {\n  color: #888888;\n  transform: scale(0.85) translateY(-25px);\n  cursor: default;\n}\n\n.tarjeta-formulario .input.focused + label {\n  color: #888888;\n}\n\n.tarjeta-formulario .input.invalid + label {\n  color: red;\n}\n\n.tarjeta-formulario .input.focused + label + .baseline {\n  background-color: #888888;\n}\n\n.tarjeta-formulario .input.focused.invalid + label + .baseline {\n  background-color: #e25950;\n}\n\n.tarjeta-formulario input, .tarjeta-formulario button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  outline: none;\n  border-style: none;\n}\n\n.tarjeta-formulario input:-webkit-autofill {\n  -webkit-text-fill-color: #e39f48;\n  transition: background-color 100000000s;\n  animation: 1ms void-animation-out;\n  -webkit-animation: 1ms void-animation-out;\n}\n\n.tarjeta-formulario .StripeElement--webkit-autofill {\n  background: transparent !important;\n}\n\n.tarjeta-formulario input, .tarjeta-formulario button {\n  animation: 1ms void-animation-out;\n  -webkit-animation: 1ms void-animation-out;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
